export function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-bold text-white mb-2">Terms &amp; Conditions</h1>
      <p className="text-slate-500 text-sm mb-10">Last updated: March 2026</p>

      <div className="space-y-8 text-slate-300 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
          <p>
            By accessing or using BookMyBand ("the Service"), you agree to be bound by these Terms &amp; Conditions.
            If you do not agree, please do not use the Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">2. Use of the Service</h2>
          <p>
            BookMyBand is a booking management tool for music venues and bands. You may use it only for lawful
            purposes and in accordance with these terms. You are responsible for maintaining the confidentiality
            of your account credentials.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">3. Data &amp; Privacy</h2>
          <p>
            We store the data you provide (venues, contacts, emails) to deliver the Service. We do not sell your
            data to third parties. Gmail access is used solely to sync and send emails on your behalf via the
            Google API. See our Privacy Policy for full details.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">4. Intellectual Property</h2>
          <p>
            All content, trademarks, and software associated with the Service are the property of BookMyBand.
            You may not copy, modify, or distribute any part of the Service without prior written consent.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">5. Limitation of Liability</h2>
          <p>
            The Service is provided "as is" without warranties of any kind. BookMyBand shall not be liable for
            any indirect, incidental, or consequential damages arising from your use of the Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">6. Changes to Terms</h2>
          <p>
            We may update these terms from time to time. Continued use of the Service after changes constitutes
            acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">7. Contact</h2>
          <p>
            Questions about these terms? Email us at{' '}
            <a href="mailto:hello@bookmyband.io" className="text-indigo-400 hover:text-indigo-300 transition-colors">
              hello@bookmyband.io
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
